/**
 * File: reports.js
 * Project: educore
 * Created Date: 2019-01-29
 * Author: Raziya S
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
class ReportsController {
    // @ngInject
    constructor($scope, $state, $rootScope, authService, localStorageService, UserPrivilages, TPWIZARDCONSTANT, $stateParams) {
        //On init function
        this.$onInit = () => {
            $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false
            if (!$rootScope.isLoggedIn) {
                $state.go("login", {}, {
                    reload: true
                })
            }
        }
        $scope.userId = localStorageService.get("user_id");
        //On destroy function
        this.$onDestroy = () => {}
        let userAccess = _.filter(localStorageService.get("feature_privileges"), function(feature) {
            return feature.module_state == "reports"
        })
        $scope.reportUserPrivilege = {};
        if (userAccess.length > 0) {
            _.each(userAccess, function(obj) {
                let user_access = {};
                _.each(obj.privilege, function(privObj) {
                    user_access[privObj.name.toLowerCase()] = privObj.status
                })
                $scope.reportUserPrivilege[obj.feature_id] = user_access;
            })
        }
        if ($scope.reportUserPrivilege.indivUsageReport && $scope.reportUserPrivilege.indivUsageReport.read) {
            $state.params.studentId = $scope.userId
            $state.params.isShowGoBack = false;
        }

    };
}

export default ReportsController;



// WEBPACK FOOTER //
// ./src/app/authoring-tool/wizard/controllers/reports/reports.js